/**
 * @file       Heading.css
 * @author     Alex Huctwith <alex@kingsds.network>
 *
 * @date       April 2022
 *
 *             Style for the title component
 */

.portal-title {
  color: black;
}

div.portal-title > h1 {
  margin: 0;
}

div.portal-title > p {
  margin: 0;
  color: #8A8A8A;
}
